import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { BatteryReplacement } from '../battery-replacement.model';
import { BatteryReplacementActions, BatteryReplacementActionTypes } from '../actions/battery-replacement.actions';

export interface State extends EntityState<BatteryReplacement> {
  isLoaded: boolean;
  isLoading: boolean;
}

export const adapter: EntityAdapter<BatteryReplacement> = createEntityAdapter<BatteryReplacement>({
  selectId: model => model.dcode
});

export const initialState: State = adapter.getInitialState({
  isLoaded: false,
  isLoading: false
});

export function reducer(
  state = initialState,
  action: BatteryReplacementActions
): State {
  switch (action.type) {
    case BatteryReplacementActionTypes.GetBatteryReplacements: {
      return {...state, isLoaded: false, isLoading: true};
    }

    case BatteryReplacementActionTypes.GetBatteryReplacementFails: {
      return {...state, isLoaded: true, isLoading: false};
    }

    case BatteryReplacementActionTypes.AddBatteryReplacement: {
      return adapter.addOne(action.payload.batteryReplacement, state);
    }

    case BatteryReplacementActionTypes.UpsertBatteryReplacement: {
      return adapter.upsertOne(action.payload.batteryReplacement, state);
    }

    case BatteryReplacementActionTypes.AddBatteryReplacements: {
      return adapter.addMany(action.payload.batteryReplacements, state);
    }

    case BatteryReplacementActionTypes.UpsertBatteryReplacements: {
      return adapter.upsertMany(action.payload.batteryReplacements, {...state, isLoaded: true, isLoading: false});
    }

    case BatteryReplacementActionTypes.UpdateBatteryReplacement: {
      return adapter.updateOne(action.payload.batteryReplacement, state);
    }

    case BatteryReplacementActionTypes.UpdateBatteryReplacements: {
      return adapter.updateMany(action.payload.batteryReplacements, state);
    }

    case BatteryReplacementActionTypes.DeleteBatteryReplacement: {
      return adapter.removeOne(action.payload.id, state);
    }

    case BatteryReplacementActionTypes.DeleteBatteryReplacements: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case BatteryReplacementActionTypes.LoadBatteryReplacements: {
      return adapter.setAll(action.payload.batteryReplacements, state);
    }

    case BatteryReplacementActionTypes.ClearBatteryReplacements: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
